import {
  fallbackImage,
  fallbackRichText,
  fallbackText,
  getDataFromLink,
} from '@landsbankinn/prismic';
import type { Prismic } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import isEmpty from 'lodash.isempty';
import React from 'react';
import { QuoteCardGroup } from '../components/card-group/QuoteCardGroup';
import { QuoteCard } from '../components/card/QuoteCard';

interface IProps {
  align: string;
  fields: [IField];
}

interface IField {
  image: Prismic.Image & {
    ar_1_1: Prismic.Image;
  };
  copy: Prismic.RichText;
  link: Prismic.Link;
  link_text: Prismic.RichText;
  isReverse: boolean;
  style: any;
}

interface ICardItemProps {
  field: IField;
}

const CardItem = ({ field }: ICardItemProps) => {
  const { image, link_text, copy, link, isReverse, style } = field;
  const linkdata = getDataFromLink(link);
  const linkText = fallbackText(link_text, linkdata?.title ?? undefined);

  return (
    <QuoteCard
      link={link}
      linkText={linkText ?? undefined}
      description={fallbackRichText(copy, linkdata?.abstract ?? undefined)}
      image={fallbackImage(image, linkdata?.image ?? undefined)}
      reverse={isReverse}
      style={style}
    />
  );
};

export const AnnualQuoteContainer = ({ align, fields }: IProps) => {
  if (isEmpty(fields)) {
    return null;
  }

  return (
    <Segment paddingBottomMobile={0} isArticle>
      <QuoteCardGroup>
        {fields?.map(({ isReverse, ...rest }, index) => {
          return (
            <CardItem
              key={`card-item-${index}`}
              field={{
                isReverse: align === 'Left' && index % 2 === 0,
                ...rest,
              }}
            />
          );
        })}
      </QuoteCardGroup>
    </Segment>
  );
};
